/**
 * クリップボードコピー + 2秒フィードバックのカスタムhook
 */
import { useCallback, useState } from 'react';
export function useCopyToClipboard() {
    const [copied, setCopied] = useState(false);
    const copy = useCallback(async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
        catch (error) {
            console.error('Failed to copy to clipboard:', error);
        }
    }, []);
    return { copied, copy };
}
//# sourceMappingURL=use-copy-to-clipboard.js.map